import { authHttp } from "./base"

export async function send_sms_code(phone) {
      console.log("authHttp", authHttp)      
      return authHttp.post('/sms/send-code', { phone: phone })
}
